// Shared on every store page: side cart, extras, free gift, menu, review scroller.
(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var T = function (k, en, v) { var d = window.CCI18N, s = (d && d[k]) || en; return v ? s.replace(/\{(\w+)\}/g, function (m, n) { return n in v ? v[n] : m; }) : s; };
  var LANG = document.documentElement.lang || 'en', LOC = /^en/i.test(LANG) ? 'en-US' : LANG;
  // Every cart call goes through the language root, so product titles come back in the page's language.
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cfgEl = $('[data-cc-offers]'), cfg = cfgEl ? JSON.parse(cfgEl.textContent) : { extras: {}, bundles: {}, tiers: {} };
  var drawer = $('[data-drawer]'), scrim = $('.cc-scrim'), lastFocus = null, compare = {}, latest = null, prefs = {}, pending = 0, hadMain = false, lastBack = 0;
  var LOCK = 'cc-price-lock', LOCK_MS = 10 * 60 * 1000, lockMem = 0, GIFT = 'cc-gift-off';
  var giftOff = store(GIFT) === '1';

  function money(c) {
    var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    // Every language copies the sample price printed by snippets/cc-money.liquid (in English that is Shopify's own money filter),
    // so each price in the cart is written exactly like the prices on the page and the extras: $1,234.56 stays $1,234.56,
    // €1.234,56 in English with euros, 1.234,56 € in German, 1 234,56 € in French. The sample is 123456 cents: six digits
    // mean decimals (the separator before the last two), four mean none (1.234 when cut off, 1,235 when rounded).
    var sample = window.CCI18N && window.CCI18N.sample, m = sample && sample.match(/\d(?:[\d.,'\s]*\d)?/);
    if (m) {
      var n = m[0], digits = n.replace(/\D/g, ''), dec = digits.length > 4 ? n.charAt(n.length - 3) : '', grp = /\d/.test(n.charAt(1)) ? '' : n.charAt(1);
      var v = ((digits === '1234' ? Math.floor(c / 100) * 100 : c) / 100).toFixed(dec ? 2 : 0).split('.');
      return sample.replace(n, v[0].replace(/\B(?=(\d{3})+(?!\d))/g, grp) + (dec ? dec + v[1] : ''));
    }
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: code }).format(c / 100); }
    catch (e) { return '$' + (c / 100).toFixed(2); }
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined) n.textContent = text;
    return n;
  }
  function plusBusinessDays(d, n) {
    var x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; }
    return x;
  }
  function plural(n, w) { return n + ' ' + T(w + (n === 1 ? '_one' : '_other'), w + (n === 1 ? '' : 's')); }

  // Jose's promise: usually 2 to 5 business days to ship, up to 7 days allowed, then 8 to 15 business days to arrive.
  // One estimated date, not the full range: 7 days plus 9 business days, close to the real middle.
  var urgency = $('[data-urgency]');
  function eta() {
    var now = new Date(), ship = new Date(now); ship.setDate(ship.getDate() + 7);
    var by = plusBusinessDays(ship, 9);
    var short = by.toLocaleDateString(LOC, { month: 'short', day: 'numeric' });
    var long = by.toLocaleDateString(LOC, { weekday: 'long', month: 'long', day: 'numeric' });
    var end = new Date(now); end.setHours(24, 0, 0, 0);
    var mins = Math.max(1, Math.ceil((end - now) / 60000)), h = Math.floor(mins / 60), m = mins % 60;
    if (urgency) urgency.textContent = T('urgency', '{h}h {m}m left to order today · Est. delivery {date}', { h: h, m: m, date: short });
    $$('[data-cart-date]').forEach(function (e) {
      e.innerHTML = '';
      T('cart_date', 'Estimated delivery {date} if you order within {time}').split(/(\{date\}|\{time\})/).forEach(function (p) {
        if (p === '{date}') e.appendChild(el('b', '', long));
        else if (p === '{time}') e.appendChild(el('b', '', h ? T('time_both', '{h} and {m}', { h: plural(h, 'hour'), m: plural(m, 'minute') }) : plural(m, 'minute')));
        else if (p) e.appendChild(document.createTextNode(p));
      });
    });
  }
  eta(); setInterval(eta, 30000);

  // A real 10-minute price promise: it starts once, never restarts on refresh, and prices don't change inside it.
  function store(key, val) {
    try {
      if (val === undefined) return localStorage.getItem(key);
      if (val === null) localStorage.removeItem(key); else localStorage.setItem(key, val);
    } catch (e) {}
    return null;
  }
  function lockTick() {
    var bar = $('[data-cart-lock]');
    if (!bar || !latest) return;
    if (!mains(latest).length) { store(LOCK, null); lockMem = 0; bar.hidden = true; return; }
    var until = Number(store(LOCK)) || lockMem;
    if (!until) { until = Date.now() + LOCK_MS; store(LOCK, String(until)); }
    lockMem = until;
    var left = Math.ceil((until - Date.now()) / 1000);
    bar.hidden = left <= 0;
    if (left > 0) $('[data-cart-lock-time]', bar).textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
  }
  setInterval(lockTick, 1000);

  function isExtra(i) { return !!cfg.extras[i.handle]; }
  function isGift(i) { return !!cfg.gift && i.handle === cfg.gift.handle; }
  function mains(c) { return c.items.filter(function (i) { return !isExtra(i) && !isGift(i); }); }
  function count(items) { return items.reduce(function (a, i) { return a + i.quantity; }, 0); }

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add('is-on'); scrim.classList.add('is-on'); drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cc-lock'); document.documentElement.classList.add('cc-lock');
    drawer.setAttribute('tabindex', '-1'); drawer.focus({ preventScroll: true });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-on'); scrim.classList.remove('is-on'); drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cc-lock'); document.documentElement.classList.remove('cc-lock');
    if (lastFocus) { lastFocus.focus({ preventScroll: true }); lastFocus = null; }
  }

  function post(url, body) {
    return fetch(ROOT + url.slice(1), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function getCart() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); }); }

  // One cart action at a time, so every step reads the cart after the last write finished.
  var queue = Promise.resolve();
  function serial(fn) { var p = queue.then(fn, fn); queue = p.catch(function () {}); return p; }

  // Keeps the cart honest after every change: extras only with a chair and once each, one free pillow per chair.
  function settle(c) {
    var chairs = count(c.items.filter(function (i) { return cfg.gift && i.handle === cfg.gift.main; }));
    var hasMain = mains(c).length > 0, fix = {}, need = false, seen = {};
    c.items.forEach(function (i) {
      if (!isExtra(i)) return;
      if (!hasMain || seen[i.handle]) { fix[i.key] = 0; need = true; return; }
      seen[i.handle] = true;
      if (i.quantity !== 1) { fix[i.key] = 1; need = true; }
    });
    var gifts = c.items.filter(isGift), more = cfg.gift ? (giftOff ? 0 : chairs) - count(gifts) : 0;
    if (more < 0) {
      var cut = -more;
      gifts.slice().reverse().forEach(function (g) { if (!cut) return; var take = Math.min(cut, g.quantity); fix[g.key] = g.quantity - take; cut -= take; need = true; });
    }
    var step = need ? post('/cart/update.js', { updates: fix }) : Promise.resolve(c);
    return step.then(function (x) {
      if (more > 0) return post('/cart/add.js', { items: [{ id: cfg.gift.id, quantity: more }] }).catch(function () {}).then(getCart);
      return need ? getCart() : x;
    });
  }

  function loadCompare(items) {
    var need = {};
    items.forEach(function (i) { if (compare[i.variant_id] === undefined) need[i.handle] = true; });
    return Promise.all(Object.keys(need).map(function (h) {
      return fetch(ROOT + 'products/' + h + '.js').then(function (r) { return r.json(); }).then(function (p) {
        p.variants.forEach(function (v) { compare[v.id] = v.compare_at_price || 0; });
      }).catch(function () {});
    }));
  }
  // The free pillow is worth $35 (cfg.gift.value, store-currency cents). Its compare-at price in other markets has taxes,
  // duties and rounding built in (EUR 43, CAD 55), so the gift is shown at the plain exchange rate instead, per pillow.
  function giftValue() {
    var rate = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
    return Math.round(((cfg.gift && cfg.gift.value) || 0) * rate / 100) * 100;
  }
  function regular(it) {
    if (isGift(it)) return giftValue() * it.quantity;
    return Math.max(compare[it.variant_id] || 0, it.original_price) * it.quantity;
  }

  function giftSwitch(on) {
    var b = el('button', 'cc-line__gift');
    b.type = 'button'; b.setAttribute('role', 'switch'); b.setAttribute('aria-checked', String(on)); b.setAttribute('aria-label', T('gift_switch', 'Include your free pillow')); b.setAttribute('data-gift', '');
    b.appendChild(el('i', 'cc-switch'));
    return b;
  }
  function giftOffRow() {
    var row = el('div', 'cc-line is-off'), pic = el('span', 'cc-line__pic'), body = el('div', 'cc-line__b'), top = el('div', 'cc-line__top');
    if (cfg.gift.image) { var img = el('img'); img.alt = ''; img.width = 88; img.height = 88; img.src = cfg.gift.image; pic.appendChild(img); }
    var pr = el('div', 'cc-line__pr');
    if (giftValue()) pr.appendChild(el('s', '', money(giftValue())));
    pr.appendChild(el('b', '', money(0)));
    top.appendChild(el('span', 'cc-line__t', cfg.gift.title)); top.appendChild(pr);
    body.appendChild(top); body.appendChild(el('small', '', T('gift_off', 'Your free gift is turned off')));
    var act = el('div', 'cc-line__act'); act.appendChild(giftSwitch(false)); body.appendChild(act);
    row.appendChild(pic); row.appendChild(body);
    return row;
  }
  function line(it) {
    var gift = isGift(it), row = el('div', 'cc-line'), body = el('div', 'cc-line__b');
    var pic = el(gift ? 'span' : 'a', 'cc-line__pic');
    if (!gift) pic.href = it.url;
    if (it.image) {
      var img = el('img'); img.alt = ''; img.width = 88; img.height = 88; img.loading = 'lazy';
      img.src = it.image + (it.image.indexOf('?') < 0 ? '?' : '&') + 'width=240';
      pic.appendChild(img);
    }
    var top = el('div', 'cc-line__top');
    var name = el(gift ? 'span' : 'a', 'cc-line__t', it.product_title + (gift && it.quantity > 1 ? ' × ' + it.quantity : ''));
    if (!gift) name.href = it.url;
    var pr = el('div', 'cc-line__pr'), reg = gift ? giftValue() : regular(it);
    if (reg > it.final_line_price) pr.appendChild(el('s', '', money(reg)));
    pr.appendChild(el('b', '', money(it.final_line_price)));
    top.appendChild(name); top.appendChild(pr); body.appendChild(top);
    if (it.variant_title) body.appendChild(el('small', '', it.variant_title));
    if (gift) body.appendChild(el('small', '', T('gift_line', 'Your holiday gift')));
    if (reg > it.final_line_price) body.appendChild(el('em', 'cc-line__you', T('you_save', 'You save {amount}', { amount: money(reg - it.final_line_price) })));
    if (gift) { var ga = el('div', 'cc-line__act'); ga.appendChild(giftSwitch(true)); body.appendChild(ga); }
    if (!gift) {
      var act = el('div', 'cc-line__act'), q = el('div', 'cc-qty');
      var minus = el('button', '', '−'), num = el('span', '', String(it.quantity)), plus = el('button', '', '+');
      minus.type = 'button'; minus.setAttribute('aria-label', T('remove_one', 'Remove one'));
      plus.type = 'button'; plus.setAttribute('aria-label', T('add_one', 'Add one'));
      minus.addEventListener('click', function () { change(it.key, it.quantity - 1, row); });
      plus.addEventListener('click', function () { change(it.key, it.quantity + 1, row); });
      q.appendChild(minus); q.appendChild(num); q.appendChild(plus);
      var rm = el('button', 'cc-line__rm', T('remove', 'Remove'));
      rm.type = 'button'; rm.setAttribute('aria-label', T('remove_item', 'Remove {item}', { item: it.product_title + ' ' + (it.variant_title || '') }));
      rm.addEventListener('click', function () { change(it.key, 0, row); });
      act.appendChild(q); act.appendChild(rm); body.appendChild(act);
    }
    row.appendChild(pic); row.appendChild(body);
    return row;
  }

  function nudge(root, c) {
    var box = $('[data-cart-nudge]', root);
    if (!box) return;
    box.innerHTML = ''; box.hidden = true;
    var handle = Object.keys(cfg.bundles).filter(function (h) { return c.items.some(function (i) { return i.handle === h; }); })[0];
    if (!handle) return;
    var mine = mains(c).filter(function (i) { return i.handle === handle; });
    var tiers = cfg.tiers, o = tiers[String(count(mine))];
    if (!o) return;
    var last = mine[mine.length - 1], price = Math.round(last.original_price * o.add / 100);
    var txt = el('div', 'cc-nudge__t');
    txt.appendChild(el('b', '', T('nudge', 'Add a {word} {item}: {n} for {price}', { word: o.word, item: cfg.bundles[handle], n: count(mine) + 1, price: money(Math.round(last.original_price * o.total / 100)) })));
    txt.appendChild(el('small', '', o.deal));
    var btn = el('button', 'cc-nudge__b', T('add_price', 'Add {price}', { price: money(price) }));
    btn.type = 'button';
    btn.addEventListener('click', function () {
      btn.disabled = true; btn.textContent = T('adding', 'Adding…');
      add([{ id: last.variant_id, quantity: 1 }]).catch(function () { btn.disabled = false; btn.textContent = T('try_again', 'Try again'); });
    });
    box.appendChild(txt); box.appendChild(btn); box.hidden = false;
  }

  function drawRoot(root, c) {
    var list = mains(c).concat(c.items.filter(isGift));
    var empty = !mains(c).length, box = $('[data-cart-items]', root);
    root.classList.toggle('is-empty', empty);
    root.classList.toggle('has-gift', !!cfg.gift && c.items.some(function (i) { return i.handle === cfg.gift.main; }));
    box.innerHTML = '';
    if (empty) {
      box.appendChild(el('p', 'cc-empty', T('cart_empty', 'Your cart is empty.')));
      var go = el('a', 'cc-cta cc-empty-cta', T('keep_shopping', 'Keep shopping'));
      go.href = cfg.shop;
      box.appendChild(go);
    }
    list.forEach(function (it) { box.appendChild(line(it)); });
    if (cfg.gift && giftOff && c.items.some(function (i) { return i.handle === cfg.gift.main; })) box.appendChild(giftOffRow());
    var reg = c.items.reduce(function (a, i) { return a + regular(i); }, 0), save = reg - c.total_price;
    $('[data-cart-total]', root).textContent = money(c.total_price);
    $('[data-cart-reg]', root).textContent = money(reg);
    $('[data-cart-save]', root).textContent = '−' + money(save);
    $('[data-row-reg]', root).hidden = save <= 0;
    $('[data-row-save]', root).hidden = save <= 0;
    nudge(root, c);
  }
  // The cart is the only truth once it holds a chair. A switch flipped before anything is added waits here.
  function syncPrefs(c) {
    var has = mains(c).length > 0;
    if (!pending) {
      if (has) Object.keys(cfg.extras).forEach(function (h) { prefs[h] = c.items.some(function (i) { return i.handle === h; }); });
      else if (hadMain) prefs = {};
    }
    hadMain = has;
  }
  function drawExtras(c) {
    $$('.cc-gift [data-gift]').forEach(function (b) { b.setAttribute('aria-checked', String(!giftOff)); });
    if (pending) return;
    $$('[data-extra]').forEach(function (b) {
      var h = b.dataset.extra, inCart = c.items.some(function (i) { return i.handle === h; });
      b.setAttribute('aria-checked', String(mains(c).length ? inCart : !!prefs[h]));
    });
  }
  function draw(c) {
    latest = c;
    syncPrefs(c);
    $$('[data-cart-count]').forEach(function (e) { var n = count(mains(c)); e.textContent = n; e.dataset.n = n; });
    drawExtras(c);
    return loadCompare(c.items).then(function () {
      if (latest === c) $$('[data-cart-root]').forEach(function (r) { drawRoot(r, c); });
      lockTick();
      return c;
    });
  }
  function settled() { return getCart().then(function (c) { return settle(c).catch(getCart); }); }
  function doRefresh() { return settled().then(draw); }
  function refresh() { return serial(doRefresh); }
  function change(key, q, row) {
    if (row) row.classList.add('is-busy');
    return serial(function () {
      return post('/cart/change.js', { id: key, quantity: q }).then(function () { return settled(); }).then(draw).catch(doRefresh);
    }).catch(function () { if (row) row.classList.remove('is-busy'); });
  }
  // Same private notes NovaGlows keeps on these lines. The underscore keeps them out of cart and checkout.
  var EXTRA_NOTES = {
    'shipping-protection': { _Service: 'Priority customer support for delivery issues', '_Order extra': 'support' },
    'priority-order-processing': { _Service: 'Priority fulfillment; normal carrier shipping times', '_Order extra': 'processing' }
  };
  function extraLine(h, parent) {
    var line = { id: cfg.extras[h].id, quantity: 1, properties: EXTRA_NOTES[h] || {} };
    if (parent) line.parent_line_key = parent.key;
    return line;
  }
  // Child lines first, so Shopify removes an extra with its item. A market without child lines keeps a plain line.
  function addExtras(handles, parent) {
    if (!handles.length) return Promise.resolve();
    return post('/cart/add.js', { items: handles.map(function (h) { return extraLine(h, parent); }) })
      .catch(function () { return post('/cart/add.js', { items: handles.map(function (h) { return extraLine(h); }) }); });
  }
  function add(items) {
    return serial(function () {
      return getCart().then(function (c) {
        var extras = mains(c).length ? [] : Object.keys(prefs).filter(function (h) { return prefs[h] && cfg.extras[h]; });
        return post('/cart/add.js', { items: items }).then(function (done) {
          if (!extras.length) return null;
          var first = (done.items || [done])[0];
          return addExtras(extras, first);
        });
      }).then(function () { return settled(); }).then(draw);
    }).then(function (c) { openCart(); return c; });
  }
  $$('[data-gift-value]').forEach(function (e) { var v = giftValue(); if (v) { e.textContent = money(v); e.style.visibility = 'visible'; } });

  function setGift(on) {
    giftOff = !on; store(GIFT, on ? null : '1');
    $$('[data-gift]').forEach(function (b) { b.setAttribute('aria-checked', String(on)); });
    return serial(doRefresh);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-gift]');
    if (b) setGift(b.getAttribute('aria-checked') !== 'true');
  });
  function paintExtra(h, on) { $$('[data-extra="' + h + '"]').forEach(function (b) { b.setAttribute('aria-checked', String(on)); }); }
  function setExtra(h, on) {
    prefs[h] = on; paintExtra(h, on); pending++;
    return serial(function () {
      return getCart().then(function (c) {
        if (!mains(c).length) return c;
        if (prefs[h] !== on) return c;
        var had = c.items.filter(function (i) { return i.handle === h; })[0];
        if (on && !had) return addExtras([h], mains(c)[0]);
        if (!on && had) return post('/cart/change.js', { id: had.key, quantity: 0 });
        return c;
      }).then(function () { pending--; return settled(); }, function (e) { pending--; throw e; }).then(draw).catch(doRefresh);
    });
  }

  // Before checkout each extra becomes a child line of the chair, so Shopify drops it with that item. Same as NovaGlows.
  function attach(c) {
    var loose = c.items.filter(function (i) { return isExtra(i) && !(i.parent_relationship && i.parent_relationship.parent_key); });
    if (!mains(c).length || !loose.length) return Promise.resolve(c);
    var drop = {}; loose.forEach(function (i) { drop[i.key] = 0; });
    return post('/cart/update.js', { updates: drop }).then(function (x) {
      var parent = mains(x)[0];
      if (!parent) return x;
      return addExtras(loose.map(function (i) { return i.handle; }), parent).then(getCart);
    });
  }

  // Coming back to a tab: another tab may have changed the same cart.
  function back() {
    var now = Date.now();
    if (now - lastBack < 1500) return;
    lastBack = now;
    refresh().catch(function () {});
  }
  window.addEventListener('focus', back);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') back(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) back(); });

  $$('[data-extra]').forEach(function (b) {
    b.addEventListener('click', function () { setExtra(b.dataset.extra, b.getAttribute('aria-checked') !== 'true'); });
  });
  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { openCart(); refresh(); }); });
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  $$('[data-checkout]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      serial(function () {
        return settled().then(function (c) {
          if (!mains(c).length) return draw(c);
          return attach(c).then(function () { location.href = a.getAttribute('href'); });
        });
      }).catch(doRefresh);
    });
  });

  var burger = $('[data-menu]'), nav = $('.cc-nav');
  function setMenu(on) { nav.classList.toggle('is-on', on); burger.setAttribute('aria-expanded', String(on)); }
  if (burger) {
    burger.addEventListener('click', function () { setMenu(!nav.classList.contains('is-on')); });
    document.addEventListener('pointerdown', function (e) { if (nav.classList.contains('is-on') && !nav.contains(e.target) && !burger.contains(e.target)) setMenu(false); });
    nav.addEventListener('click', function (e) { if (e.target.closest('a')) setMenu(false); });
  }

  // Currency picker. The form's hidden field keeps the language; return_to keeps the shopper on this page.
  var picks = $$('.cc-pick');
  document.addEventListener('click', function (e) {
    picks.forEach(function (p) { if (p.open && !p.contains(e.target)) p.open = false; });
  });
  picks.forEach(function (p) {
    p.addEventListener('toggle', function () {
      if (p.open) picks.forEach(function (o) { if (o !== p) o.open = false; });
    });
  });
  $$('.cc-pickform').forEach(function (f) {
    f.addEventListener('submit', function () {
      var back = f.querySelector('[name="return_to"]');
      if (!back) { back = document.createElement('input'); back.type = 'hidden'; back.name = 'return_to'; f.appendChild(back); }
      back.value = (location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i, '') || '/') + location.search;
    });
  });
  var countrySearch = $('[data-cc-country-search]');
  if (countrySearch) {
    countrySearch.addEventListener('input', function () {
      var q = countrySearch.value.trim().toLowerCase();
      $$('[data-cc-country]').forEach(function (b) { b.hidden = q && b.getAttribute('data-cc-country').toLowerCase().indexOf(q) < 0; });
    });
    countrySearch.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
  }

  $$('[data-rs]').forEach(function (rs) {
    var view = $('[data-rs-view]', rs), total = $$('.cc-rs__card', rs).length, at = 0, wait = null;
    function go(dir) {
      at = (at + dir + total) % total;
      view.scrollTo({ left: at * view.clientWidth, behavior: 'auto' });
    }
    view.addEventListener('scroll', function () {
      clearTimeout(wait);
      wait = setTimeout(function () { at = Math.round(view.scrollLeft / view.clientWidth); }, 200);
    }, { passive: true });
    $('[data-rs-prev]', rs).addEventListener('click', function () { go(-1); });
    $('[data-rs-next]', rs).addEventListener('click', function () { go(1); });
  });

  document.addEventListener('touchstart', function () {}, { passive: true });

  window.CC = { add: add, open: openCart, close: closeCart, refresh: refresh, money: money, setExtra: setExtra };
  refresh().then(function () { if (/[?&]cart=open/.test(location.search)) openCart(); });
})();
